import { render, staticRenderFns } from "./ProviderRequests.vue?vue&type=template&id=54530a9c&scoped=true"
import script from "./ProviderRequests.vue?vue&type=script&lang=js"
export * from "./ProviderRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54530a9c",
  null
  
)

export default component.exports